import { CountryDisplayModel, GetAllCountriesResponse, PortalkonfigurationDisplayModel } from "@/api/model-index";
import { AnredeDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/anrede-display-model";
import { InfotextDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/infotext-display-model";
import { TitelDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/titel-display-model";
import { AnredeService, CountryService, InfotextService, PortalkonfigurationService, PostleitzahlzuordnungService, TitelService } from "@/api/service-index";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map, share } from "rxjs/operators";
import { Dictionary } from "typescript-collections";

@Injectable({
    providedIn: 'root',
})
export class StammdatenService {
    protected portalkonfigurationSubject: BehaviorSubject<PortalkonfigurationDisplayModel | null> = new BehaviorSubject<PortalkonfigurationDisplayModel | null>(null);
    protected anredeSubject: BehaviorSubject<AnredeDisplayModel[] | null | undefined> = new BehaviorSubject<AnredeDisplayModel[] | null | undefined>(null);
    protected bundeslaenderSubject: BehaviorSubject<string[] | null | undefined> = new BehaviorSubject<string[] | null | undefined>(null);
    protected countrySubject: BehaviorSubject<CountryDisplayModel[] | null | undefined> = new BehaviorSubject<CountryDisplayModel[] | null | undefined>(null);
    protected titelSubject: BehaviorSubject<TitelDisplayModel[] | null | undefined> = new BehaviorSubject<TitelDisplayModel[] | null | undefined>(null);
    protected infotextSubject: BehaviorSubject<Dictionary<string, InfotextDisplayModel> | null | undefined> = new BehaviorSubject<Dictionary<string, InfotextDisplayModel> | null | undefined>(null);

    protected _infoTexte: Dictionary<string, InfotextDisplayModel> | null | undefined;
    public get InfoTexte(): Dictionary<string, InfotextDisplayModel> | null | undefined {
        return this._infoTexte;
    }
    public set InfoTexte(infos: Dictionary<string, InfotextDisplayModel> | null | undefined) {
        this._infoTexte = infos;
    }

    protected _titel: TitelDisplayModel[];
    public get Titel(): TitelDisplayModel[] {
        return this._titel;
    }
    public set Titel(infos: TitelDisplayModel[]) {
        this._titel = infos;
    }

    protected _anreden: AnredeDisplayModel[] | null | undefined;
    public get Anreden(): AnredeDisplayModel[] | null | undefined {
        return this._anreden;
    }
    public set Anreden(infos: AnredeDisplayModel[] | null | undefined) {
        this._anreden = infos;
    }

    protected _bundeslaender: string[] = [];
    public get Bundeslaender(): string[] {
        return this._bundeslaender;
    }
    public set Bundeslaender(bundeslaender: string[]) {
        this._bundeslaender = bundeslaender;
    }

    protected _portalkonfiguration: PortalkonfigurationDisplayModel;
    public get Portalkonfiguration(): PortalkonfigurationDisplayModel {
        return this._portalkonfiguration;
    }
    public set Portalkonfiguration(portalkonfiguration: PortalkonfigurationDisplayModel) {
        this._portalkonfiguration = portalkonfiguration;
    }

    protected _countries: CountryDisplayModel[];
    public get Countries(): CountryDisplayModel[] {
        return this._countries;
    }
    public set Countries(countries: CountryDisplayModel[]) {
        this._countries = countries;
    }

    constructor(protected anredeService: AnredeService, protected titelService: TitelService, protected plzzuordnungService: PostleitzahlzuordnungService, protected infotextService: InfotextService, protected portalkonfigurationService: PortalkonfigurationService, protected countryService: CountryService) {

    }

    protected countries$: Observable<CountryDisplayModel[]>;
    public GetCountries(): Observable<CountryDisplayModel[]> {
        if(this.Countries)
            return of(this.Countries);

        if (!this.countries$) {
            this.countries$ = this.countryService.apiCountryGet().pipe(
                map((response: GetAllCountriesResponse) => {
                    this.countrySubject.next(response.countries);
                    this._countries = response.countries || [];
                    return this.Countries;
                }),
                share());
        }
        return this.countries$;
    }

    protected portalkonfiguration$: Observable<PortalkonfigurationDisplayModel | null>;
    public GetPortalKonfiguration(): Observable<PortalkonfigurationDisplayModel | null> {
        if (this.Portalkonfiguration)
            return of(this.Portalkonfiguration);

        if (!this.portalkonfiguration$) {
            this.portalkonfiguration$ = this.portalkonfigurationService.apiPortalkonfigurationGet().pipe(
                map(response => {
                    this.portalkonfigurationSubject.next(response);
                    this._portalkonfiguration = response;
                    return response;
                }),
                share()
            );
        }
        return this.portalkonfiguration$;
    }

    protected anreden$: Observable<AnredeDisplayModel[]>;
    public GetAnreden(): Observable<AnredeDisplayModel[]> {
        if (this.Anreden)
            return of(this.Anreden);

        if (!this.anreden$) {
            this.anreden$ = this.anredeService.apiAnredeGet().pipe(
                map(response => {
                    this.anredeSubject.next(response.anreden);
                    this._anreden = response.anreden || [];
                    return this._anreden;
                }),
                share());
        }
        
        
        return this.anreden$;
    }

    protected titel$: Observable<TitelDisplayModel[]>;
    public GetTitel(): Observable<TitelDisplayModel[]> {
        if (this.Titel)
            return of(this.Titel);

        if (!this.titel$) {
            this.titel$ = this.titelService.apiTitelGet().pipe(
                map(response => {
                    this.titelSubject.next(response);
                    this.Titel = response;
                    return response;
                }),
                share());
        }
        return this.titel$;
    }

    protected bundeslaender$: Observable<string[]>;
    public GetBundeslaender(): Observable<string[]> {
        if (!this.bundeslaender$) {
            this.bundeslaender$ = this.plzzuordnungService.apiPostleitzahlzuordnungGetAllBundeslaenderGet().pipe(
                map(response => {
                    this._bundeslaender = response;
                    return response;
                }),
                share());
        }
        return this.bundeslaender$;
    }

    protected infotexte$: Observable<Dictionary<string, InfotextDisplayModel> | null | undefined>;
    public GetInfoTexte(): Observable<Dictionary<string, InfotextDisplayModel> | null | undefined> {

        let dictInfotexte: Dictionary<string, InfotextDisplayModel> = new Dictionary<string, InfotextDisplayModel>();
        if (!this.infotexte$) {

            this.infotexte$ = this.infotextService.apiInfotextGet().pipe(
                map(response => {
                    response.infotexte?.forEach(info => {
                        if (info.schluessel && !dictInfotexte.containsKey(info.schluessel))
                            dictInfotexte.setValue(info.schluessel, info);
                    });

                    this.infotextSubject.next(dictInfotexte);

                    this._infoTexte = dictInfotexte;
                    return dictInfotexte;
                }),
                share()
            );
        }
        return this.infotexte$;
    }
}
